export default {
  eyebrow: 'Portal de socios',
  title: 'Impuestos y moneda',
  description:
    'Categorías de impuestos predeterminadas que heredan sus restaurantes a menos que las anulen individualmente.',
};
